import { trackFirstContentfulPaint } from './trackFirstContentfulPaint';
import { trackFirstInput } from './trackFirstInput';
import { trackNavigationTimings } from './trackNavigationTimings';
import { trackLargestContentfulPaint } from './trackLargestContentfulPaint';
import { trackFirstHidden } from './trackFirstHidden';
export function trackInitialViewMetrics(configuration, viewStart, setLoadEvent, scheduleViewUpdate) {
  var initialViewMetrics = {};
  var _trackNavigationTimin = trackNavigationTimings(configuration, function (navigationTimings) {
      setLoadEvent(navigationTimings.loadEvent);
      initialViewMetrics.navigationTimings = navigationTimings;
      scheduleViewUpdate();
    }),
    stopNavigationTracking = _trackNavigationTimin.stop;
  var firstHidden = trackFirstHidden(configuration, viewStart);
  var _trackFirstContentful = trackFirstContentfulPaint(configuration, firstHidden, function (firstContentfulPaint) {
      initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
      scheduleViewUpdate();
    }),
    stopFCPTracking = _trackFirstContentful.stop;
  var _trackLargestContentf = trackLargestContentfulPaint(configuration, firstHidden, window, function (largestContentfulPaint) {
      initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
      scheduleViewUpdate();
    }),
    stopLCPTracking = _trackLargestContentf.stop;
  var _trackFirstInput = trackFirstInput(configuration, firstHidden, function (firstInput) {
      initialViewMetrics.firstInput = firstInput;
      scheduleViewUpdate();
    }),
    stopFIDTracking = _trackFirstInput.stop;
  function stop() {
    stopNavigationTracking();
    stopFCPTracking();
    stopLCPTracking();
    stopFIDTracking();
    firstHidden.stop();
  }
  return {
    stop: stop,
    initialViewMetrics: initialViewMetrics
  };
}